import React, { ChangeEvent, Dispatch, SetStateAction } from 'react'

import toast from 'react-hot-toast'

import { InputFileContainer } from './style'
import { useStorage } from '../../../context'
import { AudioRef, FileItem } from '../../../types'
import { UploadAudioBtn } from '../../buttons'
import { Spacer } from '../../global'
import { SectionSubtitle } from '../../texts'

const FileComponent = ({
  files,
  setFiles,
  defaultValue,
}: {
  files: FileItem[]
  setFiles: Dispatch<SetStateAction<FileItem[]>>
  defaultValue: AudioRef[]
}) => {
  const { loadingStorage, progressBar } = useStorage()

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.files ? Array.from(event.target.files) : []

    if (selected.length === 0) return

    const newItems = selected.map((f) => ({
      id: `${f.name}-${f.size}-${f.lastModified}`,
      file: f,
      progress: 0,
      uploaded: false,
    }))

    setFiles((prev) => {
      const _existingIds = new Set(prev.map((it) => it.id))
      const usedTitles = new Set(
        defaultValue.map((audio) => audio.title.toLowerCase()),
      )
      const uniqueItems = newItems.filter((item) => {
        const normalizedTitle = item.file.name.toLowerCase()
        if (_existingIds.has(item.id) || usedTitles.has(normalizedTitle)) {
          toast.error(
            `El archivo "${item.file.name.slice(0, item.file.name.lastIndexOf('.'))}" ya existe.`,
          )
          return false
        }
        _existingIds.add(item.id)
        usedTitles.add(normalizedTitle)
        return true
      })

      return uniqueItems.length > 0 ? [...prev, ...uniqueItems] : prev
    })

    event.target.value = ''
  }

  return (
    <>
      <InputFileContainer>
        <UploadAudioBtn
          htmlFor="file-input"
          disableLabel={
            (progressBar !== null && progressBar > 0 && progressBar < 100) ||
            files.length > 0 || // deshabilita mientras hay selección pendiente
            loadingStorage
          }
          label="Seleccionar archivos"
        />

        <input
          type="file"
          onChange={handleFileChange}
          className="file-upload"
          id="file-input"
          accept=".mp4,.m4a,.mp3"
          multiple
        />
      </InputFileContainer>
      <div style={{ width: '100%' }}>
        <Spacer height={5} />
        <SectionSubtitle
          fontSize={11}
          fontWeight={400}
          children="* Solo admite archivos .mp3, .mp4 y .m4a"
          textAlign="left"
        />
        <Spacer height={5} />
      </div>
    </>
  )
}

export default FileComponent
